import { render } from "./IAFeedbackNew.vue?vue&type=template&id=25745a2c&scoped=true"
import script from "./IAFeedbackNew.vue?vue&type=script&lang=js"
export * from "./IAFeedbackNew.vue?vue&type=script&lang=js"

import "./IAFeedbackNew.vue?vue&type=style&index=0&id=25745a2c&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25745a2c"]])

export default __exports__